type TopbarContentItem = {
  text?: string;
  label?: {
    gearsResolvedRichText?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

const FREE_SHIPPING_BANNER_TEXT = "sales shipping";
const THRESHOLD_REGEX = /\d+(?:[.,]\d+)?/g;

const isTopbarContentItem = (item: unknown): item is TopbarContentItem =>
  typeof item === "object" && item !== null;

export const getExistingContent = (
  content: unknown[] | undefined,
  thresholdEnabled: boolean,
  threshold: string | number | undefined,
): unknown[] => {
  const baseContent = content ?? [];
  const thresholdText = threshold === undefined ? "0" : String(threshold);

  if (!thresholdEnabled) {
    return baseContent.filter(
      (item) =>
        !(isTopbarContentItem(item) && item.text === FREE_SHIPPING_BANNER_TEXT),
    );
  }

  return baseContent.map((item) => {
    if (!isTopbarContentItem(item) || item.text !== FREE_SHIPPING_BANNER_TEXT) {
      return item;
    }

    const currentBannerText = item.label?.gearsResolvedRichText;
    if (typeof currentBannerText !== "string") {
      return item;
    }

    return {
      ...item,
      label: {
        ...item.label,
        gearsResolvedRichText: currentBannerText.replace(
          THRESHOLD_REGEX,
          thresholdText,
        ),
      },
    };
  });
};
